// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1N8P6","header":"MergedInvoice_header__3V-Qu"};